import React, { useState, useCallback, useContext, useEffect, useMemo } from 'react'
import '../OemDetails/OemDetails.css'
import '../AuctionRoom/AuctionRoom.css'
import CustomBreadcrumbs from '@/custom/components/atoms/CustomBreadcrumbs'
import ImageGallery from 'react-image-gallery'
import CustomDialog from '@/product/components/organisms/Dialog'
import { Box, Tab, Tabs, Typography } from '@material-ui/core'
import brochure from '../../assets/images/brochure.svg'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { Button } from '@material-ui/core'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import AlertContext from '@/product/context/alert/alertContext'
import finance from '../../assets/images/finance.svg'
import wheel from '../../assets/images/wheel-icon.svg'
import { OemGrid } from '../OemDetails/OemGrid'
import CommonContext from '@/custom/context/common/commonContext'
import CommonFront from '@/custom/context/frontCommon/settingContext'
import ProductSlider from '@/custom/components/molecules/ProductSlider'
import AuthContext from '@/product/context/auth/authContext'
import SignContext from '@/custom/context/signContext'
import { handleRedirectInternal } from '@/custom/common/components'
import { mapData } from '@/product/common/components'
function TabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`pv-tabpanel-${index}`}
            aria-labelledby={`pv-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    )
}

const NewEquipmemt = (props) => {
    const product = props.data || {}
    const commonContext = useContext(CommonContext)
    const { searchValue, allCategory, allOem, allbrand, allModel } = commonContext
    const authContext = useContext(AuthContext)
    const commonFront = useContext(CommonFront)
    const {
        responseStatus: responseStatusUser,
        generateInitialBU,
        searchTableActionEnquiry,
        searchTableActionDemo,
        clearResponse: clearResponseCard,
    } = commonFront

    const {
        loginPopup,
        handleLoginPopup,
        kycPopup,
        handleKycPopup,
        handleBusign,
        handleRequestCallbackModal,
    } = useContext(SignContext)
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const { user, isAuthenticated } = authContext
    const brand = useMemo(() => {
        if (product.brand_id) {
            const i = allbrand
                ? allbrand.find((value) => value.id == product.brand_id)?.display_name
                : ''

            return i
        }
        return ''
    }, [product.brand_id, allbrand])
    const category = useMemo(() => {
        if (product.category_id) {
            const i = allCategory
                ? allCategory.find((value) => value.id == product.category_id)?.display_name
                : ''

            return i
        }
        return ''
    }, [product.category_id, allCategory])
    const model = useMemo(() => {
        if (product.model_id) {
            const i = allModel ? allModel.find((value) => value.id == product.model_id)?.name : ''

            return i
        }
        return ''
    }, [product.model_id, allModel])
    const breadcrumbs = [
        { label: 'Home', link: '/' },
        { label: 'New Equipment List', link: '/new-equipment-listing' },
        { label: 'New Equipment Detail', link: '/newequipment/1' },
    ]
    const [tabIndex, setTabIndex] = useState(0)
    const forklifts = [
        { title: 'Forklift 1', price: '₹1,00,000' },
        { title: 'Forklift 2', price: '₹1,20,000' },
        { title: 'Forklift 3', price: '₹1,00,000' },
        { title: 'Forklift 4', price: '₹1,20,000' },
        { title: 'Forklift 5', price: '₹1,50,000' },
    ]
    const theme = { theme: { colors: '#1976d2' } }

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue)
    }
    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }
    const [changeStatusDemo, setChangeStatusDemo] = useState(false)
    const changeChangeStatusDemo = () => {
        setChangeStatusDemo(!changeStatusDemo)
    }
    const enquiryFormik = useFormik({
        initialValues: {
            id: 0,
            description: '',
            status: 1,
        },
        // validationSchema: validationCard,
        enableReinitialize: true,
        onSubmit: (values) => {
            values.project_id = data.id
            values.user_id = user.id
            searchTableActionEnquiry(values)
        },
    })
    const demoFormik = useFormik({
        initialValues: {
            id: 0,
            avl_time: '',
            start_date: '',
            end_date: '',
            status: 1,
        },
        // validationSchema: validationCard,
        enableReinitialize: true,
        onSubmit: (values) => {
            values.project_id = product.id
            values.user_id = user.id
            searchTableActionDemo(values)
        },
    })
    useEffect(() => {
        if (responseStatusUser) {
            if (responseStatusUser.from == 'searchTableActionEnquiry') {
                if (responseStatusUser.status === 'success') {
                    changeChangeStatus()
                    enquiryFormik.resetForm()
                    enquiryFormik.handleReset()
                }
                setAlert(responseStatusUser.message, responseStatusUser.status || 'error')
            } else if (responseStatusUser.from == 'searchTableActionDemo') {
                if (responseStatusUser.status === 'success') {
                    changeChangeStatusDemo()
                    demoFormik.resetForm()
                    demoFormik.handleReset()
                }
                setAlert(responseStatusUser.message, responseStatusUser.status || 'error')
            }

            clearResponseCard()
        }
    }, [responseStatusUser])
    const enquiryDetails = {
        formik: enquiryFormik,
        data: [
            {
                label: 'Please enter your enquiry details*',
                type: 'text',
                placeholder: 'Your enquiry details goes here',
                class: 'col-12',
                name: 'card_name',
            },
        ],
    }
    const demoDetails = {
        formik: demoFormik,
        data: [
            {
                type: 'misc',
                content: 'Availability Date',
                class: 'col-12 col-sm-12 mb-3 sectionLabel',
            },
            {
                label: 'Start Date',
                upperLabel: true,
                name: 'start_date',

                type: 'date',
                class: 'col-6',
            },
            {
                label: 'End Date',
                upperLabel: true,
                name: 'end_date',
                type: 'date',
                class: 'col-6',
            },
            {
                type: 'misc',
                content: 'Availability Time',
                class: 'col-12 col-sm-12 mb-3 sectionLabel',
            },
            {
                label: 'Availability Time',
                hideTitle: true,
                type: 'radio',
                name: 'avl_time',
                options: [
                    { id: 0, description: 'Prelunch' },
                    { id: 1, description: 'Postlunch' },
                ],
                int: 1,
                // filter: true,
            },
        ],
    }
    return (
        <div className="oemDetalis auctionRoom">
            <CustomDialog
                title={'Send your enquiry to us'}
                open={changeStatus}
                function={changeChangeStatus}
                style={{ minWidth: '350px' }}
            >
                <div className="row">{mapData(enquiryDetails)}</div>

                <div className="actionWrapper">
                    <Button id="cardDetails_cancel" onClick={() => changeChangeStatus()}>
                        Cancel
                    </Button>
                    <form onSubmit={enquiryFormik.handleSubmit} autoComplete="nofill">
                        <PrimaryButton
                            id="cardDetails_confirm"
                            type="submit"
                            label="Make Enquiry"
                        />
                    </form>
                </div>
            </CustomDialog>
            <CustomDialog
                title={'Demo Request'}
                open={changeStatusDemo}
                function={changeChangeStatusDemo}
                style={{ minWidth: '350px' }}
            >
                <div className="row">{mapData(demoDetails)}</div>

                <div className="actionWrapper">
                    <Button id="cardDetails_cancel" onClick={() => changeChangeStatusDemo()}>
                        Cancel
                    </Button>
                    <form onSubmit={demoFormik.handleSubmit} autoComplete="nofill">
                        <PrimaryButton id="cardDetails_confirm" type="submit" label="Book Demo" />
                    </form>
                </div>
            </CustomDialog>
            <div className="productViewCont">
                <div className="productViewCont-header">
                    <CustomBreadcrumbs items={breadcrumbs} />
                    <div className="productViewCont-inner valuation-container p-0">
                        <div className="row">
                            <div className="col-md-6 contImagegallery">
                                <ImageGallery
                                    items={props.images}
                                    thumbnailPosition="bottom"
                                    showNav={true}
                                    onErrorImageURL="/assets/images/noImage.png"
                                    showBullets={false}
                                    showFullscreenButton={true}
                                    showPlayButton={false}
                                />
                            </div>
                            <div className="col-md-6 pt-3 pr-4 pl-0">
                                <div className="product-detail-summary text-left">
                                    <h1 className="product-detail-title">{brand}</h1>
                                    <div className="product-detail-name">
                                        <span>{category}</span>
                                        <span>
                                            <span className="circle-dot"></span>
                                            {model}
                                        </span>
                                    </div>
                                    <div className="product-detail-price">
                                        <div
                                            itemProp="price"
                                            className="product-price-request"
                                            onClick={() =>
                                                handleRequestCallbackModal({
                                                    status: true,
                                                    project_id: product.id,
                                                })
                                            }
                                        >
                                            Price On Request
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="product-detail-link">
                                        <div className="product-finance-link row">
                                            <a href="#" className="col-md-6">
                                                <img alt="brochure" src={brochure} />
                                                <span>Brochure</span>
                                            </a>
                                            <a href="#" className="col-md-6">
                                                <img alt="finace" src={finance} />
                                                <span>Finance</span>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="row mt-4">
                                        <div
                                            className="col-sm-6 col-md-6 col-lg-6"
                                            onClick={() => {
                                                if (!isAuthenticated) {
                                                    handleLoginPopup()
                                                } else {
                                                    changeChangeStatus()
                                                }
                                            }}
                                        >
                                            <button className="btn btn-outline-primary btn-block">
                                                Make an Enquiry
                                            </button>
                                        </div>
                                        <div
                                            className="col-sm-6 col-md-6 col-lg-6"
                                            onClick={() => {
                                                if (!isAuthenticated) {
                                                    handleLoginPopup()
                                                } else {
                                                    changeChangeStatusDemo()
                                                }
                                            }}
                                        >
                                            <button className="btn btn-theme btn-block">
                                                Book a demo
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="productViewCont-inner valuation-container p-0 text-left">
                        <img src={wheel} alt="Wheel Image" className="img-fluid p-2" />
                    </div>
                    <div className="productViewCont-inner valuation-container p-0">
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs
                                value={tabIndex}
                                onChange={handleTabChange}
                                aria-label="equipment info tabs"
                                className="custom-tabs"
                            >
                                <Tab label="Basic Information" />
                                <Tab label="Technical Information" />
                            </Tabs>
                        </Box>
                        <TabPanel value={tabIndex} index={0}>
                            <Typography variant="body1" sx={{ mt: 2 }}>
                                <div className="row text-left">
                                    <div className="col-md-4 d-flex flex-column">
                                        Asset Id <strong>251</strong>
                                        <br />
                                    </div>
                                    <div className="col-md-4 d-flex flex-column">
                                        Category <strong>Tractor</strong>
                                        <br />
                                    </div>
                                    <div className="col-md-4 d-flex flex-column">
                                        Brand/Model <strong>Akana</strong>
                                        <br />
                                    </div>
                                </div>
                            </Typography>
                            <hr />
                            <Typography variant="body1" sx={{ mt: 2 }}>
                                <div className="row text-left">
                                    <div className="col-md-4 d-flex flex-column">
                                        Menufaturing Year <strong>2015</strong>
                                        <br />
                                    </div>
                                    <div className="col-md-4 d-flex flex-column">
                                        Price (Excl. Tax.) <strong>Price On Request</strong>
                                        <br />
                                    </div>
                                </div>
                            </Typography>
                        </TabPanel>
                        <TabPanel value={tabIndex} index={1}>
                            <Typography variant="body1" sx={{ mt: 2 }}>
                                <div className="row text-left">
                                    <div className="col-md-4 d-flex flex-column">
                                        Fuel Type <strong>Diesel</strong>
                                        <br />
                                    </div>
                                </div>
                            </Typography>
                        </TabPanel>
                    </div>
                    <div className="productViewCont-inner productViewCont valuation-container p-0 text-left bg-transparent box-shadow-none">
                        {/* <ProductSlider>
                            <OemGrid forklifts={forklifts} theme={theme} />
                        </ProductSlider> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NewEquipmemt
